// constants
import { DesignationActionTypes } from './constants';
import { DesignationDataType } from 'src/types/designation';
export type DesignationActionType = {
    type:
        | DesignationActionTypes.API_RESPONSE_SUCCESS
        | DesignationActionTypes.API_RESPONSE_ERROR
        | DesignationActionTypes.ADD_DESIGNATION
        | DesignationActionTypes.EDIT_DESIGNATION
        | DesignationActionTypes.GET_DESIGNATION
        | DesignationActionTypes.GET_DESIGNATIONS
        | DesignationActionTypes.RESET
        | DesignationActionTypes.RESET_SUCCESS
        | DesignationActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const designationApiResponseSuccess = (
    actionType: string,
    data: DesignationDataType | [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): DesignationActionType => ({
    type: DesignationActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const designationApiResponseError = (
    actionType: string,
    data: DesignationDataType | [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): DesignationActionType => ({
    type: DesignationActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addDesignation = (params: any): DesignationActionType => ({
    type: DesignationActionTypes.ADD_DESIGNATION,
    payload: params,
});

export const editDesignation = (params: any): DesignationActionType => ({
    type: DesignationActionTypes.EDIT_DESIGNATION,
    payload: params,
});
export const GetDesignations = (params: any): DesignationActionType => ({
    type: DesignationActionTypes.GET_DESIGNATIONS,
    payload: params,
});

export const GetDesignation = (params: any): DesignationActionType => ({
    type: DesignationActionTypes.GET_DESIGNATION,
    payload: params,
});

export const resetDesignation = (): DesignationActionType => ({
    type: DesignationActionTypes.RESET,
    payload: {},
});

export const resetDesignationSuccess = (): DesignationActionType => ({
    type: DesignationActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetDesignationError = (): DesignationActionType => ({
    type: DesignationActionTypes.RESET_ERROR,
    payload: {},
});
